module.exports = __webpack_public_path__ + "img/privacy_info1_1.dff268ae.png";